import { render, staticRenderFns } from "./User.vue?vue&type=template&id=6a97701e&scoped=true"
import script from "@/views/Users/User.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/User.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/user.scss?vue&type=style&index=0&id=6a97701e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a97701e",
  null
  
)

export default component.exports